import { ContactPerson } from './contact-person.model';
import { Country } from './country.model';

import { Type } from 'class-transformer';
import { TravelInsurance } from './travel-insurance.model';

export class Insuree {
    ipaId: string;
    ipaParentId: string;
    ipaInitials: string;
    ipaFirstName: string;
    ipaLastName: string;
    ipaMaidenName: string;
    ipaPartyGender: any;
    @Type(() => Date) ipaDateOfBirth: Date;
    ipaBsnCitizenServiceNumber: string;
    ipaPostalCode: string;
    ipaHouseNumber: string;
    ipaHouseNumberAddition: string;
    ipaStreetName: string;
    ipaCity: string;
    country = new Country();
    ipaPhoneNumber = '';
    ipaPhoneNumber2 = '';
    ipaEmail = '';
    ipaNoEmail: boolean;
    ipaRemarks: string;
    ipaContactInitiation: string;
    ipaContactTelephone: string;
    ipaContactWith: string;
    ipaContactEmail= ''
    ipaContactComment: string;
    ipaSharePrivateInformation :boolean
    ContactPersons: ContactPerson[] = [];
    TravelInsurances : TravelInsurance[]=[];
}